import {Route,Switch,BrowserRouter } from "react-router-dom";

import DoobiHeader from "components/Headers/DoobiHeader";
import LaundryOrderDetailsPage from "components/Doobi/LaundryOrderDetails";
import LaundryOrdersTable from "components/Doobi/LaundryOrders";
import ScanQrPage from "components/Doobi/ScanQr";
import TagQrCodesPage from "components/Doobi/TagQrCodes";
import ScanQrCodesPage from "components/Doobi/ScanQrCodes";

const LaundryOrdersRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Orders" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/scanQrs/:id`} component={ScanQrCodesPage}/>
      <Route path={`${match.path}/tagQrs/:id`} component={TagQrCodesPage}/>
      <Route path={`${match.path}/scanQr`} component={ScanQrPage}/>
      <Route path={`${match.path}/:id`} component={LaundryOrderDetailsPage}/>
      <Route path={`${match.path}/`} component={LaundryOrdersTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default LaundryOrdersRoute;
